module.exports = __webpack_public_path__ + "./images/472d81a2078d4a4a9d780171af50a367.webp";